/**
 * Canonical ACCEPTED VIA order for fiat settlement rails.
 * Domestic / instant first, then clearing, then international.
 * Unknown rail ids sort after the known list, alphabetically by id.
 */
const RAIL_ORDER: Record<string, number> = {
  FP: 0,
  SCTINST: 1,
  SCT: 2,
  CHAPS: 3,
  SWIFT: 4,
};

/**
 * Returns a new array of rails sorted for consistent scanning across
 * chooser cards, detail badges, copy-all, and settlement-instruction PDFs.
 * Does not mutate the input.
 */
export function sortSettlementRails<T extends { id: string }>(
  rails: readonly T[]
): T[] {
  return [...rails].sort((a, b) => {
    const aKnown = Object.hasOwn(RAIL_ORDER, a.id);
    const bKnown = Object.hasOwn(RAIL_ORDER, b.id);
    const aRank = aKnown ? RAIL_ORDER[a.id]! : Number.POSITIVE_INFINITY;
    const bRank = bKnown ? RAIL_ORDER[b.id]! : Number.POSITIVE_INFINITY;
    if (aRank !== bRank) {
      return aRank - bRank;
    }
    if (!aKnown && !bKnown) {
      return a.id.localeCompare(b.id);
    }
    return 0;
  });
}
